import styled from 'styled-components';

import { mobileGridCSS, webGridCss } from './styles';
import { IContentProps } from './types';

const Content = styled.div<IContentProps>`
  margin: 0;
  max-width: ${Styles.layout.sectionMaxWidth};
  display: grid;

  padding: 1rem 0.5rem 50px;
  grid-gap: 1rem;
  ${(p: IContentProps) => mobileGridCSS(p)}
  grid-template-columns: 100%;

  ${Styles.desktop`
    padding: 1rem 1rem 50px;
  `}

  ${Styles.desktopLarge`
    padding: 2rem 3rem;
    ${({ isCateringOrder }: IContentProps) => isCateringOrder && 'padding-top: 0;'};
    grid-gap: 2rem;
    ${(p: IContentProps) => webGridCss(p)}
    grid-template-columns: minmax(0, 6fr) minmax(min-content, 4fr);
    grid-template-rows: min-content min-content 1fr;
    margin: 0 auto;
  `}

  ${Styles.mobileFullscreen`
    margin-top: 2rem; /* service mode header height */
  `}
`;

export default Content;
